import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const menuItemVariants = cva(
  "flex w-full cursor-pointer items-center gap-2 rounded-s px-3 py-2 text-left text-body2 hover:bg-neutral-background-200 disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50",
  {
    variants: {
      variant: {
        default: "text-neutral-text-800",
        destructive: "text-state-negative",
      },
    },
    defaultVariants: { variant: "default" },
  },
)

/**
 * Row inside a Popover / custom menu. Renders with `role="menuitem"`.
 * Use inside a container with `role="menu"`.
 */
function MenuItem({
  className,
  variant,
  ...props
}: React.ComponentProps<"button"> & VariantProps<typeof menuItemVariants>) {
  return (
    <button
      type="button"
      role="menuitem"
      data-slot="menu-item"
      className={cn(menuItemVariants({ variant }), className)}
      {...props}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { MenuItem, menuItemVariants }
